import { Comic, Section } from "../../types";
import {
  trackRecsysItemLastViewForSection,
} from "../../analytics/recsys/tracking";

export function getCalendarMaxItems(
  breakpoint: string | undefined,
): number {
  if (breakpoint === "xs" || breakpoint === "sm") return 3;
  if (breakpoint === "md" || breakpoint === "lg") return 4;
  return 6;
}

export function trackCalendarVisibleItems(params: {
  comics: Comic[];
  maxItems: number;
  section: Section;
  sectionIndex?: number;
}): void {
  void params;
}

export function trackCalendarLastView(params: {
  comics: Comic[];
  maxItems: number;
  section: Section;
  sectionIndex?: number;
}): void {
  const { comics, maxItems, section, sectionIndex } = params;
  if (sectionIndex === undefined) {
    return;
  }

  const visibleCount = Math.min(comics.length, maxItems);
  if (visibleCount <= 0) {
    return;
  }

  trackRecsysItemLastViewForSection(section, sectionIndex, visibleCount - 1);
}
